// SERVICES CREATION
export const CREATE_SERVICE = "CREATE_SERVICE";
export const CREATED_SERVICE = "CREATED_SERVICE";
export const RECOVERY_SERVICE = "RECOVERY_SERVICE";
export const RECOVERY_NOT_DELIVERED_SERVICE = "RECOVERY_NOT_DELIVERED_SERVICE";
export const RECOVERY_NOT_DELIVERED_BOOKING = "RECOVERY_NOT_DELIVERED_BOOKING";
export const RETRY_CREATE_SERVICE = "RETRY_CREATE_SERVICE";
export const HANG_UP = "HANG_UP";
export const HOLD = "HOLD";

// SCHEDULED EVENTS
export const CHECK_DELIVERED_SERVICES = "CHECK_DELIVERED_SERVICES";
export const CHECK_DELIVERED_BOOKINGS = "CHECK_DELIVERED_BOOKINGS";
export const DISCARD_EXPIRED_NOT_DELIVERED_NOTIFICATIONS =
  "DISCARD_EXPIRED_NOT_DELIVERED_NOTIFICATIONS";
export const FETCH_LIVE_SERVICES = "FETCH_LIVE_SERVICES";
export const FETCH_BOOKINGS = "FETCH_BOOKINGS";
export const FETCH_HISTORIC_TRIPS = "FETCH_HISTORIC_TRIPS";
export const CHECK_FOR_NEW_AVAILABLE_VERSION = "CHECK_FOR_NEW_AVAILABLE_VERSION";
export const CHECK_NOTIFICATIONS = "CHECK_NOTIFICATIONS";
export const CHECK_CALLS_STATUS = "CHECK_CALLS_STATUS";
export const DELETE_ANSWERED_CALL = "DELETE_ANSWERED_CALL";

// FIRED BY SCHEDULED MAINLY
export const UPDATE_BOOKING_SERVICES = "UPDATE_BOOKING_SERVICES";
export const UPDATE_LIVE_SERVICES = "UPDATE_LIVE_SERVICES";
export const UPDATE_HISTORIC_SERVICES = "UPDATE_HISTORIC_SERVICES";
export const NEW_VERSION_AVAILABLE = "NEW_VERSION_AVAILABLE";
export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export const UPDATE_CALLS_STATUS = "UPDATE_CALLS_STATUS";

// NOTIFICATIONS
export const NEW_NOTIFICATION = "NEW_NOTIFICATION";
export const CLEARED_NOTIFICATION = "CLEARED_NOTIFICATION";

// ERRORS
export const ERROR_FETCHING_LIVE_SERVICES = "ERROR_FETCHING_LIVE_SERVICES";
export const ERROR_FETCHING_BOOKINGS = "ERROR_FETCHING_BOOKINGS";
export const ERROR_CREATING_SERVICE = "ERROR_CREATING_SERVICE";
export const ERROR_FETCHING_HISTORIC_SERVICES = "ERROR_FETCHING_HISTORIC_SERVICES";

// CONSTANTS
export const TIME_BEFORE_MARK_AS_NOT_DELIVERED = 20;
export const EXPIRE_NOT_DELIVERED_NOTIFICATIONS_AFTER_SECONDS = 1800; // 30 minutes
